import styled from '@emotion/styled';
import { Color, FontSize, ROUTER_PATH } from 'views/constants';
import { localeIds } from 'locals';
import { Typography } from 'views/components/atoms/Typography';
import { LinkText } from 'views/components/molecules/LinkText';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: auto;
  padding: 16px 16px;
  border-radius: 4px;
  background: ${Color.C17};
`;

interface ConfigurationProfileInfoProps {
  osVersion: string;
  onReInstall: () => void;
}

export const ConfigurationProfileInfo: React.FC<
  ConfigurationProfileInfoProps
> = ({ osVersion, onReInstall }) => {
  const ReInstallProfileFontSize = FontSize.XS;

  const reInstallProfileLink = (chunks: React.ReactNode[]): React.ReactNode => (
    <LinkText
      key="reInstallProfile"
      size={ReInstallProfileFontSize}
      onClick={onReInstall}
      to={ROUTER_PATH.apps}
      anotherTab={false}
    >
      {chunks}
    </LinkText>
  );

  return (
    <Wrapper>
      <Typography size={FontSize.XS} color={Color.C1} block>
        <FormattedMessage
          id={localeIds.configurationProfileInfo.suggestUpdate}
          values={{
            deviceOsVersion: osVersion,
            reInstallProfile: reInstallProfileLink,
          }}
        />
      </Typography>
    </Wrapper>
  );
};
